import { IconName } from "@fortawesome/fontawesome-svg-core";
import clsx from "clsx";
import LIconCard from "../licon-card/LIconCard";
import WButton from "../wbutton/WButton";
import { useRouter } from "next/router";
import { motion } from "framer-motion";
import parse from "html-react-parser";
import LAppDownloadIcons from "../lapp-download-icons/LAppDownloadIcons";
import fbEvent from "@/utils/fbEvent";

/* eslint-disable-next-line */
export interface LIconCardsSectionProps {
  id?: string;
  topTitle: string;
  mainTitle: string;
  subTitle: string;
  hasExclamationMark?: boolean;
  iconCards: {
    iconName: IconName;
    title: string;
    subTitle?: string;
    large?: boolean;
  }[];
  centerText?: boolean;
  buttons?: {
    text: string;
    url: string;
  }[];
  backgroundColor?: string;
  showAppButton?: boolean;
}

export const LIconCardsSection = (props: LIconCardsSectionProps) => {
  const router = useRouter();
  return (
    <div
      id={props?.id}
      className="py-20"
      style={{
        backgroundColor: props?.backgroundColor ?? "#F6F8FA",
      }}
    >
      <div
        className={clsx([
          props?.centerText && "items-center text-center",
          "container flex flex-col gap-5 px-4 mx-auto lg:max-w-7xl",
        ])}
      >
        <div className="-mb-5 text-xl font-semibold text-ekgreen">
          {props?.topTitle}
        </div>
        <span className="flex items-center gap-3">
          <h1 className={clsx([props?.backgroundColor && "text-white"])}>
            {parse(props?.mainTitle)}
          </h1>
          {props?.hasExclamationMark && (
            <img src="/img/exclamation-mark.svg" alt="exclamation mark" />
          )}
        </span>
        <div
          className={clsx([
            props?.backgroundColor && "text-white",
            "text-base lg:text-2xl",
          ])}
        >
          {props?.subTitle}
        </div>
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false }}
          transition={{ duration: 1, type: "spring", delay: 0.3 }}
          className="flex flex-wrap justify-center gap-3 mt-10 lg:gap-5"
        >
          {props?.iconCards?.map((card, idx) => (
            <LIconCard
              key={idx}
              iconName={card?.iconName as IconName}
              title={card?.title}
              subTitle={card?.subTitle}
              large={card?.large}
            />
          ))}
        </motion.div>
        {props?.showAppButton && (
          <div className="flex items-center justify-center mt-20 -mb-40">
            <LAppDownloadIcons />
          </div>
        )}

        {props?.buttons && (
          <div className="flex flex-col gap-5 mt-20 ">
            {props?.buttons?.map((button, idx) => (
              <WButton
                key={idx}
                text={button?.text}
                type="primary-red-btn"
                className="mx-auto w-fit lg:mx-0"
                onClick={() => {
                  button?.url && router.push(button?.url);
                  fbEvent("Schedule");
                }}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LIconCardsSection;
